import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import emailjs from "emailjs-com";
import { toast } from "react-toastify";
import HeaderBanner from './HeaderBanner';

const ContactUs = () => {

    const [form, setForm] = useState({ Name: "", Mobile: "", Email: "", Message: "" });

    const sendEmail = (e: any) => {
        e.preventDefault();
        emailjs
            .send(
                "service_yb3k31k",
                "template_c57ipnh",
                form,
                "oUe5Px_prYF6Tyu0Y"
            )
            .then(() => {
                toast.success("Form Submit Successfully Admin will contact you soon!", {
                    position: "top-center"
                });
            }
            )
            .catch((err: any) => console.log(err));
    };

    return (
        <>
            <HeaderBanner heading={'Contact Us'} imagePath="assets/images/banners/contact.jpg" />
            <section className="about about-1" id="about-1" style={{ background: 'rgb(235, 230, 230)', marginTop: '30px' }}>
                <div className="container">
                    <div className="row" >
                        <div className='center-heading'>
                            <h2 className="heading-with-border center-heading">Contact Us</h2>
                        </div>

                    </div>
                </div>
            </section>
            {/* <!-- Contact Page Area Start --> */}
            <section className="bleezy-contact-page-area section_b_70">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-sm-6">
                            <div className="single-contact-address">
                                <h3>ADMIN OFFICE</h3>
                                <ul>
                                    <li>
                                        <i className="fas fa-map-marker-alt"></i>
                                        <p>A.J.L Nehru Road
                                            Kolkata(West Bengal) -700013

                                            <span style={{ visibility: 'hidden' }}> A.J.L Nehru Road Kolkata(West Bengal) -700013</span>
                                        </p>

                                    </li>
                                    <li>
                                        <i className="fas fa-phone-alt"></i>
                                        <p>+91 9721336714
                                        </p>
                                    </li>
                                    <li>
                                        <i className="fas fa-envelope"></i>
                                        <p>info@octopussindia.com</p>
                                        {/* <p style={{ visibility: 'hidden' }}>
                                            A.J.L Nehru Road Kolkata(West Bengal) -700013
                                        </p> */}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-6">
                            <div className="single-contact-address">
                                <h3>REGISTERED OFFICE</h3>
                                <ul>
                                    <li>
                                        <i className="fas fa-map-marker-alt"></i>
                                        <p>Mishra Sadan , 26A/13 C Muir Road, Saraswatipuram Colony, Rajapur ( Beside Chandra Guest House), Prayagraj(UP)-211002</p>
                                    </li>
                                    <li>
                                        <i className="fas fa-phone-alt"></i>
                                        <p>+91 9454311900</p>
                                    </li>
                                    <li>
                                        <i className="fas fa-envelope"></i>
                                        <p>info@octopussindia.com</p>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            {/* <!-- Contact Page Area End --> */}



            {/* <!-- Contact Form Area Start --> */}
            <section className="" style={{ marginTop: '15px', background: '#ddd', paddingTop: '30px', paddingBottom: '30px' }} >
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-12 col-xl-12 col-xxl-12">
                            <div className="contact-card">
                                <div className="contact-body">
                                    <h5 className="card-heading" style={{ textAlign: 'center' }}>Reach Out to Us</h5>
                                    <p className="card-desc" style={{ textAlign: 'center' }}>Our experts will reply you very soon</p>
                                    <form className="contactForm" method="post" onSubmit={sendEmail}>
                                        <div className="row">
                                            <div className="col-12 col-md-4">
                                                <input className="form-control" type="text" id="contact-name" name="contact-name" placeholder="Name" required={true} />
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <input className="form-control" type="email" id="contact-email" name="contact-email" placeholder="Email" required={true} />
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <input className="form-control" type="text" id="contact-phone" name="contact-phone" placeholder="Phone" required={true} />
                                            </div>

                                            <div className="col-12">
                                                <textarea className="form-control" id="contact-infos" placeholder="additional information" name="contact-infos" required={true}></textarea>
                                            </div>
                                            <div className="col-12">
                                                <button className="btn btn--secondary-dark justify-content-between" style={{ width: '200px' }}>submit message <i className="icon-arrow-right"></i></button>
                                            </div>
                                            <div className="col-12">
                                                <div className="contact-result"></div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                {/* <!-- End .contact-body --> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ContactUs;